export default __webpack_public_path__ + "static/media/turkey_black_male.9d8c3735.png";